// AutoReminderDialog.js
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material'

const AutoReminderDialog = ({ open, onClose, onConfirm, currentStatus }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirm Auto Reminder</DialogTitle>
      <DialogContent>
        Are you sure you want to {currentStatus ? 'disable' : 'enable'} the Auto Reminder feature?
    
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onConfirm} variant="contained" color="primary">
          {currentStatus ? 'Disable' : 'Enable'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AutoReminderDialog